import React from "react";
import styled from "styled-components";
import { animated } from "react-spring";

const NavBar = styled(animated.div)`
  width: 100%;
  background: red;
  height: 200px;
`;

export default (props) => {
  return <NavBar style={props.style}>

  </NavBar>;
};
